import { render, staticRenderFns } from "./Trainingsplan.vue?vue&type=template&id=6787458d&scoped=true&"
import script from "./Trainingsplan.vue?vue&type=script&lang=js&"
export * from "./Trainingsplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6787458d",
  null
  
)

export default component.exports